import { FormSelect } from '../../forms/integrated-form-controls/form-select';
import React from 'react';
import { EventPanelFormType } from '@mark43/cad-api';
import { useEnabledFeatures } from '../../common/hooks/enabled-features/use-enabled-features';
import { useIntegratedForm } from '../../forms/use-integrated-form';
import { useOriAliases } from '../../common/hooks/use-ori-aliases';

interface OriAliasSelectProps {
    isFirstResponder: boolean;
    isPersisted: boolean;
}

export const EventPanelFormOriAliasSelect = ({
    isFirstResponder,
    isPersisted,
}: OriAliasSelectProps) => {
    const { changeOriAlias } = useEnabledFeatures();
    const oriAliasOptions = useOriAliases();
    const { form } = useIntegratedForm<EventPanelFormType>();

    if (oriAliasOptions.length === 0) {
        return null;
    }

    return (
        <FormSelect
            length={isFirstResponder ? 'md' : 'sm'}
            control={form.control}
            asEditable={!!isPersisted}
            options={oriAliasOptions}
            isDisabled={!changeOriAlias}
            name="oriAliasOption"
            label="Query Region"
        />
    );
};
